export default function getToken() {
  return localStorage.getItem("@arbo:accessToken");
}